import instance from '../axios';

export const getAll = async () => {
  const response = await instance.get(`purchase-orders`);
  return response.data;
};
export const getForGR = async () => {
  const response = await instance.get(`purchase-orders/getForGR`);
  return response.data;
};
export const getDetails = async (id) => {
  const response = await instance.get(`purchase-orders/` + id);
  return response.data;
};
export const insert = async (data) => {
  const response = await instance.post(`purchase-orders`, data);
  return response;
};
export const update = async (data) => {
  const response = await instance.put(`purchase-orders`, data);
  return response;
};
export const remove = async (id) => {
  const response = await instance.delete(`purchase-orders/` + id);
  return response;
};

export const transfer = async (data) => {
  const response = await instance.post(`purchase-orders/transfer`, data);
  return response;
};

export const passwordValidation = async (data) => {
  const response = await instance.post(`purchase-orders/password`, data);
  return response;
};
